import { bool, object } from "prop-types";
import styled from "styled-components/macro";
import { rem } from "polished";

import { colors, fonts } from "../../../styles/Styles.variables";
import { routes } from "../../../constants/routes";

import { Link } from "react-router-dom";

import PageLegal from "./Page.legal";
import PageLogo from "./Page.logo";
import PageLogoHoltCat from "./Page.logo-holtcat";

function PageDesktopFooterColophon({
  authenticated = false,
  location,
  signupFooterShow,
}) {
  return (
    <Colophon>
      <Brand signupFooterShow={signupFooterShow}>
        {signupFooterShow ? <LogoHoltCat /> : <Logo />}
      </Brand>
      <Legal />
      <DisclaimerNav>
        <li>
          <Link to={routes.privacy.path}>{routes.privacy.title}</Link>
        </li>
        <li>
          <Link to={routes.terms.path}>{routes.terms.title}</Link>
        </li>
        <li>
          <Link to={routes.disclosures.path}>{routes.disclosures.title}</Link>
        </li>
      </DisclaimerNav>
      {!authenticated && (
        <LoginLink
          to={{ pathname: routes.login.path, state: { from: location } }}
        >
          {routes.login.title}
        </LoginLink>
      )}
    </Colophon>
  );
}

const Colophon = styled.div`
  margin-right: ${rem("18px")};
  width: min(20.33898305vw, ${rem("240px")});

  @media (min-width: ${rem("1180px")}) {
    margin-right: 0;
    width: min(26.52777778vw, ${rem("382px")});
  }
`;

const Brand = styled.div`
  margin-bottom: ${rem("29px")};
  max-width: 100%;
  width: ${rem("150px")};

  @media (min-width: ${rem("1240px")}) {
    width: ${({ signupFooterShow }) =>
      signupFooterShow ? rem("180px") : rem("215px")};
  }
`;

const baseLogoStyles = `
  height: 0;
  overflow: hidden;
  max-width: 100%;
  position: relative;

  svg {
    bottom: 0;
    display: block;
    height: 100%;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;
  }`;

const Logo = styled(PageLogo)`
  padding-top: 11.336032389%;
  ${baseLogoStyles}
`;

const LogoHoltCat = styled(PageLogoHoltCat)`
  padding-top: 28.504672897%;
  ${baseLogoStyles}
`;

const Legal = styled(PageLegal)`
  color: ${colors.gray500};
  font-size: ${rem("12px")};
  line-height: 1.41666667;
  margin: 0;
  padding-bottom: ${rem("6px")};
  text-wrap: balance;

  @media (min-width: ${rem("1180px")}) {
    padding-right: clamp(${rem("68px")}, 7.42424242%, ${rem("98px")});
  }
`;

const DisclaimerNav = styled.ul`
  list-style: none;
  margin: 0 0 ${rem("23px")};
  padding: 0;

  li {
    margin: ${rem("11px")} 0;
  }

  @media (min-width: ${rem("1240px")}) {
    display: flex;
    flex-wrap: wrap;

    li:not(:last-child) a:after {
      content: "|";
      margin-left: ${rem("7px")};
      margin-right: ${rem("7px")};
    }
  }

  a {
    color: ${colors.gray300};
    display: block;
    font-size: ${rem("12px")};
    outline: none;
    text-decoration: none;
    transition: color 0.3s ease-in-out;
    white-space: nowrap;

    @media (min-width: ${rem("1180px")}) {
      font-size: ${rem("13px")};
    }

    &:active,
    &:focus,
    &:hover {
      color: ${colors.white};
    }
  }
`;

const LoginLink = styled(Link)`
  color: ${colors.green400};
  font-size: ${rem("13px")};
  font-weight: ${fonts.weights.bold};
  outline: none;
  text-transform: uppercase;
  white-space: nowrap;

  &:focus,
  &:hover {
    text-decoration: none;
  }
`;

PageDesktopFooterColophon.propTypes = {
  authenticated: bool,
  location: object,
  signupFooterShow: bool,
};

export default PageDesktopFooterColophon;
